module.exports = __webpack_public_path__ + "64fea8405d1ec77fcacd3c894601a8c2.pdf";